import { Tag } from "types/Models/FCA";
import { emptyApi } from "./emptyApi";
import { Task } from "types/Models/task";

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getTaskTag: build.query<Tag[], void>({
      query: () => {
        return { url: `/api/inkle/tags/TASK_TAG/` };
      },
      providesTags: ["TASK_TAGS"],
    }),

    createTaskTag: build.mutation<
      Tag,
      { title: string; colorHex?: string | null; bgColorHex?: string | null }
    >({
      query: ({ title, colorHex = null, bgColorHex = null }) => {
        return {
          url: `/api/inkle/tags/create/TASK_TAG/`,
          method: "POST",
          body: { title, color_hex: colorHex, bg_color_hex: bgColorHex },
        };
      },
      invalidatesTags: (result) => (result ? ["TASK_TAGS"] : []),
    }),

    getAllTaskStates: build.query<{ name: string; uuid: string }[], void>({
      query: () => {
        return { url: `/api/inkle/tasks/get_all_task_states/` };
      },
    }),

    getTaskData: build.query<
      Task,
      {
        uuid: string;
      }
    >({
      query: ({ uuid }) => {
        return { url: `/api/inkle/tasks/${uuid}/` };
      },
    }),

    addTags: build.mutation({
      query: ({ taskId, tagId }) => {
        return {
          url: `/api/inkle/tags/tasks/${taskId}/tag/${tagId}/`,
          method: "POST",
        };
      },
      invalidatesTags: (result) =>
        result ? ["All_SERVICE_PROVIDERS", "Tasks", "BOOKKEEPING_TASKS"] : [],
    }),
    removeTags: build.mutation({
      query: ({ taskId, tagId }) => {
        return {
          url: `/api/inkle/tags/tasks/${taskId}/tag/${tagId}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: (result) =>
        result ? ["All_SERVICE_PROVIDERS", "Tasks", "BOOKKEEPING_TASKS"] : [],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTaskTagQuery,
  useCreateTaskTagMutation,
  useGetAllTaskStatesQuery,
  useGetTaskDataQuery,
  useLazyGetTaskDataQuery,
  useAddTagsMutation,
  useRemoveTagsMutation,
} = extendedApi;
